{
  "sf_user_permission_checker": {
    "filters_title": "FILTROS",
    "search_placeholder": "Buscar...",
    "header": "Comprobador de Permisos Tuvis",
    "cols": {
      "name": "Nombre del Componente",
      "label": "Etiqueta del Componente",
      "parent": "Objeto Principal",
      "type": "Tipo",
      "viewPermission": "Permiso de Visualización",
      "writePermission": "Permiso de Escritura"
    },
    "permission": {
      "allow": "Permitir",
      "denied": "Denegado",
      "unknown": "Desconocido",
      "none": "Ninguno"
    },
    "type": {
      "class": "Clase Apex",
      "field": "Campo Personalizado",
      "object": "Objeto Personalizado",
      "visualforce_page": "Página Visualforce"
    }
  },
  "new_word": "Nuevo",
  "crm_settings": {
    "country_code": "Código de país",
    "users_deactivation": "Desactivación de usuarios",
    "auto_sync": "Sincronización automática"
  },
  "chat_component": {
    "message_history": "Historial de Mensajes",
    "date_cannot_be_older_than_x_months": "La fecha no puede ser anterior a {{months}} meses",
    "select_all": "Seleccionar Todo",
    "deselect_all": "Deseleccionar todo",
    "export_pdf": "Exportar PDF",
    "export_csv": "Exportar CSV",
    "edited": "Editado",
    "deleted": "Eliminado",
    "loading": "Cargando",
    "synced_messages": "Mensajes sincronizados",
    "by_tuvis": "por Tuvis",
    "no_message_1": "Aún no hay mensajes",
    "no_message_2": "Activa la opción de sincronización automática en el Panel de Agente Tuvis para comenzar a sincronizar chats",
    "selected": "seleccionado",
    "delete_messages": "Eliminar mensajes",
    "download_messages": "Descargar",
    "synced_by": "Sincronizado por",
    "sent_by": "Enviado por",
    "received_by": "Recibido por",
    "filters_title": "FILTRAR MENSAJES SINCRONIZADOS",
    "search_group_placeholder": "Buscar grupo",
    "search_input_placeholder": "Buscar mensajes",
    "search_matches": "{{currentIndex}} de {{numOfMatches}} coincidencias",
    "today": "Hoy",
    "yesterday": "Ayer",
    "groups": "Grupos",
    "personal": "Personal",
    "no_link": "No groups currently linked",
    "premium_feature_header": "🔓 Desbloquear función premium",
    "premium_feature_text": "Actualiza para acceder a nuestra función premium y lleva tu experiencia al siguiente nivel.",
    "premium_feature_contact_sales": "Contacta con ventas",
    "voice_message": "Mensaje de voz",
    "last_months": "Últimos {{months}} meses",
    "messages_created_date": "Fecha de creación de mensajes",
    "by_last_months": "Por los últimos meses",
    "by_date_range": "Por rango de fechas",
    "date_cannot_be_in_future": "La fecha no puede estar en el futuro",
    "from_date_cannot_be_bigger_then_to_date": "La fecha inicial no puede ser posterior a la fecha final",
    "to_date_cannot_be_smaller_then_from_date": "La fecha final no puede ser anterior a la fecha inicial",
    "from": "Desde",
    "to": "Hasta",
    "apply": "Aplicar",
    "contact": {
      "name_one": "{{contactName}}",
      "name_other": "{{contactName}} y {{numberOfContacts}} más",
      "footer_one": "Mensaje",
      "footer_other": "Ver todos",
      "modal_header_one": "Ver Contacto",
      "modal_header_other": "{{count}} Contactos",
      "birthday": "Cumpleaños"
    },
    "you": "Tú",
    "customer": "Cliente",
    "click_to_remove": "Haz clic para eliminar",
    "forwarded": "Reenviado",
    "broadcast_list": "Lista de difusión",
    "location": "Ubicación",
    "disappearing_message": "Mensaje temporal"
  },
  "autoSyncPage": {
    "header": "Sincronización automática",
    "modalTitle": "Eliminar mensajes",
    "modalButton": "Eliminar",
    "desc": "Eliminar todo el historial de mensajes sincronizados de todos los contactos. Esta acción no se puede deshacer.",
    "button": "Eliminar todos los mensajes",
    "confirmDeleteModalText": "Esto eliminará todos los mensajes de WhatsApp que se hayan sincronizado con Salesforce, incluyendo todos los estados que cada usuario haya creado y cualquier otra configuración relacionada con la sincronización automática.",
    "confirmDeleteModalConfirm": "Estás seguro/a de esto?",
    "delete_all_placeholder": "Escribe 'DELETE ALL' para continuar",
    "delete_success": "Todas las mensajes se han eliminado correctamente",
    "delete_failure": "Operación fallida. Por favor, contacta al soporte",
    "loading": "Cargando"
  },
  "usersDeactivationPage": {
    "never": "Nunca",
    "Every_1_hour": "Cada 1 hora",
    "Every_6_hour": "Cada 6 horas",
    "Every_6_hour_desc": "Se ejecuta todos los días a las 12 a.m., 6 a.m., 12 p.m., 6 p.m.",
    "Every_12_hour": "Cada 12 horas",
    "Every_12_hour_desc": "Se ejecuta todos los días a las 12 a.m., 12 p.m.",
    "Every_24_hour": "Cada 24 horas",
    "Every_24_hour_desc": "Se ejecuta todos los días a las 12 a.m.",
    "Every_2_days": "Cada 2 días",
    "Every_2_days_desc": "Se ejecuta los lunes, miércoles y viernes a las 12 a.m.",
    "Every_7_days": "Cada 7 días",
    "Every_7_days_desc": "Se ejecuta todos los domingos a las 12 a.m.",
    "header": "Desactivación de usuario",
    "runNow": "Ejecutar ahora",
    "saveSettings": "Guardar configuración",
    "previousRun": "Ejecución anterior",
    "nextRun": "Próxima ejecución",
    "modal_start_now": "Inicio de ejecución del trabajo exitoso",
    "modal_finish_now": "Trabajo finalizado exitosamente",
    "modal_saved_interval": "Nuevo intervalo de trabajo guardado exitosamente",
    "desc": "Establecer un intervalo de desactivación automática de usuario:",
    "loading": "Cargando"
  },
  "autoSyncActivitiesPage": {
    "never": "Nunca",
    "Every_1_hour": "Cada 1 hora",
    "Every_6_hour": "Cada 6 horas",
    "Every_6_hour_desc": "Se ejecuta todos los días a las 12 a.m., 6 a.m., 12 p.m., 6 p.m.",
    "Every_12_hour": "Cada 12 horas",
    "Every_12_hour_desc": "Se ejecuta todos los días a las 12 a.m., 12 p.m.",
    "Every_24_hour": "Cada 24 horas",
    "Every_24_hour_desc": "Se ejecuta todos los días a las 12 a.m.",
    "Every_2_days": "Cada 2 días",
    "Every_2_days_desc": "Se ejecuta los lunes, miércoles y viernes a las 12 a.m.",
    "Every_7_days": "Cada 7 días",
    "Every_7_days_desc": "Se ejecuta todos los domingos a las 12 a.m.",
    "runNow": "Ejecutar ahora",
    "saveSettings": "Guardar configuración",
    "previousRun": "Ejecución anterior",
    "nextRun": "Próxima ejecución",
    "modal_start_now": "Inicio de ejecución del trabajo exitoso",
    "modal_finish_now": "Trabajo finalizado exitosamente",
    "modal_saved_interval": "Nuevo intervalo de trabajo guardado exitosamente",
    "loading": "Cargando",
    "header": "Sincronización automática de actividades",
    "desc": "Establecer un intervalo de creación automática de actividades:"
  },
  "autoSyncCasesPage": {
    "header": "Sincronización automática de casos",
    "desc": "Establezca un intervalo para la creación automática de casos:"
  },
  "country_codes": {
    "title": "Administrar códigos de país",
    "manage_codes": "Administrar códigos de países",
    "test_tool": "Herramienta de prueba",
    "test_tool_description": "Inserta un número de teléfono igual que en Salesforce para ver la respuesta de enrutamiento",
    "phone_number": "Número de teléfono",
    "test_now": "Prueba ahora",
    "invalid_phone": "el teléfono de entrada no coincide con el del teléfono móvil",
    "copy_to_clipboard": "Copiar al portapapeles",
    "test_results_copied": "Resultados de la prueba copiados al portapapeles",
    "manage_codes_subtitle": "Selecciona el código de país que usas con más frecuencia.",
    "manage_codes_desctiption": "Actualizamos esta configuración cada 24 horas. Para actualizarlos ahora, cierra sesión y vuelve a iniciar sesión en el panel de agente.",
    "search_countries": "Buscar países",
    "save": "Guardar cambios",
    "max_countries_recommendation": "Se recomienda incluir hasta 5 códigos de país",
    "max_countries_warning": "Solo puedes seleccionar hasta 5 códigos de países",
    "saved_successfully": "Las configuraciones de código de país se guardaron exitosamente",
    "saved_failed": "Error al guardar las configuraciones de código de país",
    "loading": "Cargando"
  },
  "chat_groups": {
    "title": "Grupos de Chat",
    "group_name": "Nombre grupo",
    "participants": "Participantes",
    "number_of_messages": "Número de mensajes",
    "last_message": "Last message",
    "search_groups": "Buscar grupos",
    "no_groups_to_show": "There are no groups to show",
    "no_results_found": "No results found",
    "try_different_keywords": "Try different keywords or make sure",
    "spelled_correctly": "everything is spelled correctly.",
    "back_to_groups_chats": "Back to Groups Chats",
    "number_of_participants": "{{numberOfMembers}} participants",
    "entity_unknown": "Unknown",
    "entity_contact": "Contact",
    "entity_lead": "Lead",
    "entity_blacklisted": "Bloqueado",
    "entity_blocked": "Bloqueado",
    "User": "User",
    "entity_sf_user": "Salesforce User",
    "entity_sf_manager": "Salesforce Manager",
    "entity_account": "Account",
    "search_matches": "{{currentIndex}} out of {{numOfMatches}} matches",
    "no_records_found": "No records found",
    "open_group_panel_to_link": "Open the group panel to link contacts",
    "search_message": "Search message",
    "selected": "Selected",
    "delete_messages": "Delete messages",
    "premium_feature_header": "Función premium",
    "message_only_for_upgraded_users": "Esta opción está disponible solo para usuarios premium",
    "filters": {
      "created_by_me": "Creado por mí",
      "groups_im_in": "Grupos en los que estoy",
      "no_groups_to_show": "No hay grupos para mostrar con las condiciones actuales de los filtros"
    }
  },
  "entity_sf_user": "User",
  "error_try_again": "Please try again later",
  "search_person": {
    "loading": "Loading..."
  },
  "entity_filter": {
    "me": "Yo",
    "clear_all": "Borrar todo",
    "reset_filter": "Restablecer filtro"
  },
  "admin_only": "This page is only for Tuvis Admin!",
  "admin_or_sys_admin_only": "This page is only for Tuvis Admin or System Admin!",
  "missing_template_tuvis_custom_permission": "You don't have access to this page. Please contact your Salesforce Administrator. Required custom permission: Tuvis_Allow_Access_To_Templates_Tab",
  "user_management": {
    "headers": {
      "user_details": "Detalles del Usuario",
      "configurations": "Configuraciones"
    },
    "delete_pending_user_modal": {
      "line1": "Are you sure you want to remove <{{email}}>?",
      "line2": "They will not have access to Tuvis.",
      "title": "Are you sure?"
    },
    "disable_user_modal": {
      "line1": "This will immediately revoke the access for this user.",
      "line2": "Are you sure about it?",
      "title": "Disable user",
      "okText": "Disable user"
    },
    "user_layout_modal": {
      "title": "Layout de usuario"
    },
    "invite_user_modal": {
      "username": "Usuario",
      "primary_user_must_manage_users": "Usuario principal debe tener permiso para administrar otros usuarios",
      "inherited_from_group": "Heredado de {{groupNames}}",
      "subtitle": "Detalles del admin",
      "title": "Invitar miembros a Tuvis",
      "new_org": "New organization",
      "org_name": "Organization name",
      "okText": "Invitar ({{emailsToInviteCount}})",
      "user_update_success": "Usuario actualizado correctamente",
      "user_update_failure": "Error al actualizar el usuario",
      "email": "Email",
      "first_name": "Nombre",
      "last_name": "Apellido",
      "notify_inviter_on_sidecar_events": "Notificarme sobre las conexiones de Remote Sync",
      "permissions": {
        "title": "Permisos",
        "update_success": "Permisos actualizados correctamente",
        "update_failure": "Permisos no actualizados",
        "show_analytics_ui": "Acceso Insights de Usuarios",
        "show_dashboards_ui": "Acceso a Dashboards",
        "analytics_compliance": "Acceso a Cumplimiento",
        "show_chat_groups_ui": "Acceso Chat de Grupos",
        "sidecars_enabled": "Acceso Remote Sync UI",
        "allow_inviting_users": "Acceso Gestión de usuarios UI",
        "allow_desktop_lite": "Acceso a Tuvis Desktop lite",
        "allow_platform_integrations": "Acceso Integraciones UI",
        "allow_platform_admin_notifications": "Acceso a Notificaciones UI",
        "allow_platform_global_layout": "Acceso al Layout global UI",
        "access_audit_log": "Acceso Registro de auditoría UI",
        "show_saml_settings": "Acceder a la Configuración de SSO"
      },
      "granular_permissions": {
        "sidecars_enabled": "Tuvis Remote Sync",
        "sidecars": {
          "view": "Ver",
          "create": "Crear",
          "invite": "Invitar",
          "update": "Actualizar",
          "delete": "Eliminar",
          "view_messages": "Ver mensajes",
          "all": "Todo",
          "notifications": "Notificaciones"
        },
        "allow_platform_integrations": "Integraciones",
        "allow_messages_analytics": "Análisis de Mensajes",
        "messages_analytics": {
          "view": "Ver"
        },
        "destinations": {
          "view": "Ver",
          "update": "Actualizar",
          "delete": "Eliminar",
          "all": "Todo"
        },
        "show_saml_settings": "Configuración de SSO",
        "saml": {
          "view": "Ver",
          "update": "Actualizar",
          "all": "Todo"
        },
        "access_audit_log": "Registro de auditoría",
        "audit_log": {
          "view": "Ver"
        },
        "allow_platform_global_layout": "Layout global",
        "global_layout": {
          "view": "Ver",
          "update": "Actualizar",
          "all": "Todo"
        },
        "allow_platform_admin_notifications": "Notificaciones",
        "notifications": {
          "view": "Ver",
          "update": "Actualizar",
          "all": "Todo"
        },
        "allow_desktop_lite": "Tuvis Desktop lite",
        "allow_mobile_call_recording": "Allow mobile call recordings",
        "allow_inviting_users": "Gestión de usuarios",
        "user_management": {
          "view": "Ver",
          "invite": "Invitar",
          "activate": "Activar",
          "update_permissions": "Actualizar permisos",
          "view_groups": "Ver grupos",
          "update_groups": "Actualizar grupos",
          "assign_groups": "Asignar grupos",
          "edit_user": "Editar usuario",
          "view_messages": "Ver mensajes",
          "all": "Todo"
        },
        "show_chat_groups_ui": "Chat de Grupos",
        "chat_groups": {
          "view": "Ver"
        },
        "show_im_groups_ui": "Grupos de MI",
        "im_groups": {
          "view": "Ver"
        },
        "show_analytics_ui": "Panel de participación",
        "analytics": {
          "view": "Ver",
          "view_messages": "Ver mensajes"
        },
        "show_dashboards_ui": "Dashboards",
        "show_custom_filters_ui": "Filtros personalizados",
        "dashboards": {
          "view": "Ver",
          "update": "Actualizar",
          "create": "Crear",
          "all": "Todo"
        },
        "custom_filters": {
          "view": "Ver",
          "update": "Actualizar",
          "create": "Crear",
          "all": "Todo"
        },
        "analytics_compliance": "Cumplimiento",
        "compliance": {
          "view": "Ver"
        },
        "allow_incidents": "Incidentes",
        "incident": {
          "view": "Ver incidentes",
          "update": "Actualizar incidentes"
        },
        "allow_dlp": "Data Loss Protection",
        "enable_surveillance": "Surveillance",
        "surveillance": {
          "view": "Ver políticas",
          "update": "Actualizar políticas",
          "view_incidents": "Ver incidentes",
          "view_analytics": "Ver análisis",
          "update_incidents": "Actualizar incidentes",
          "all": "Todo"
        },
        "dlp": {
          "view": "Ver políticas",
          "update": "Actualizar políticas",
          "view_analytics": "Ver analytics",
          "all": "Todo"
        },
        "allow_waba": "WhatsApp Business API",
        "waba": {
          "view_settings": "Ver configuraciones",
          "update_settings": "Ajustes de actualización",
          "agent": "Agent",
          "all": "Todo"
        },
        "tuvis_call_recording": "Grabación de llamadas de Tuvis",
        "twilio": {
          "view_settings": "Ver configuraciones",
          "update_settings": "Ajustes de actualización",
          "agent": "Agent",
          "all": "Todo"
        },
        "allow_customer_facing_settings": "Configuraciones",
        "settings": {
          "view_general": "Ver configuraciones",
          "update_general": "Actualizar configuraciones",
          "all": "Todo"
        },
        "allow_public_api": "Claves API",
        "api_keys": {
          "view": "Ver",
          "update": "Actualizar",
          "all": "Todo"
        },
        "allow_url_policy": "Política de URL",
        "url_policy": {
          "view": "Ver",
          "update": "Actualizar",
          "all": "Todos"
        },
        "allow_keyword_insights": "Análisis de palabras clave",
        "keyword_insights": {
          "view": "Ver",
          "update": "Actualizar",
          "view_analytics": "Ver análisis",
          "all": "Todo"
        },
        "allow_phones_blocklist": "Lista de Teléfonos Bloqueados",
        "phones_blocklist": {
          "view": "Ver",
          "update": "Actualizar",
          "all": "Todos"
        },
        "allow_blocked_phones": "Bloquear Teléfonos (chat)",
        "blocked_phones": {
          "view": "Ver",
          "update": "Actualizar",
          "all": "Todos"
        },
        "allow_phones_whitelist": "Lista de Teléfonos Permitidos",
        "phones_whitelist": {
          "view": "Ver",
          "update": "Actualizar",
          "all": "Todos"
        },
        "allow_tuvis_contacts": "Tuvis Contacts",
        "tuvis_contacts": {
          "view": "Ver",
          "update": "Actualizar",
          "create": "Crear",
          "all": "Todos"
        },
        "allow_slack_platform": "Plataforma de Slack",
        "slack": {
          "view_settings": "Ver configuraciones",
          "update_settings": "Actualizar configuraciones",
          "all": "Todos"
        },
        "allow_teams_platform": "Plataforma de Teams",
        "teams": {
          "view_settings": "Ver configuraciones",
          "update_settings": "Actualizar configuraciones",
          "all": "Todos"
        },
        "allow_bot_builder": "Bot Builder",
        "allow_elite_token": "Token de Seguridad Elite",
        "elite_token": {
          "all": "Todo",
          "view": "Ver",
          "update": "Generar"
        },
        "bot_builder": {
          "view_analytics": "Ver analytics",
          "view": "Ver",
          "update": "Actualizar",
          "view_triggers": "Ver disparadores",
          "trigger_flows": "Disparar flujos",
          "all": "Todos"
        },
        "fraud_detection": "Detección de Fraude",
        "phishing_fraud_detection": "Detección de Phishing",
        "fraud": {
          "view": "Ver",
          "update": "Actualizar",
          "view_incidents": "Ver incidentes",
          "view_urls": "Ver URLs",
          "update_urls": "Actualizar URLs",
          "update_incidents": "Actualizar incidentes",
          "all": "Todos"
        },
        "allow_archive": "Archivo",
        "archive": {
          "view_settings": "Ver configuraciones",
          "update_settings": "Actualizar configuraciones",
          "all": "Todos"
        },
        "allow_im_templates": "Plantillas de mensajes",
        "im_templates": {
          "all": "Todos",
          "view": "Ver",
          "create": "Crear",
          "update": "Actualizar",
          "delete": "Eliminar"
        }
      }
    },
    "no_users_to_show": "There are no users to show",
    "no_pending_users_to_show": "There aren’t any pending members",
    "title": "Gestión de Usuarios",
    "purchased_licenses": "{{numOfSeats}} Licencias Compradas",
    "consumed_licenses": "{{numOfUsedSeats}} Licencias Consumidas",
    "users_count": "{{activeSeats}} Usuarios",
    "download_csv": "Download CSV",
    "invite_users": "Invitar usuarios",
    "drop_csv": "Suelta el archivo CSV aquí o haz clic para buscar",
    "csv_errors": {
      "empty_file": "El archivo CSV está vacío",
      "missing_required_headers": "Faltan encabezados requeridos en el archivo CSV: {{missingRequiredHeaders}}",
      "invalid_headers": "El archivo CSV contiene encabezados inválidos: {{invalidHeaders}}",
      "invalid_emails": "El archivo CSV contiene filas con correos electrónicos inválidos: {{invalidEmails}}",
      "invalid_phones": "El archivo CSV contiene filas con teléfonos inválidos: {{invalidPhones}}",
      "missing_first_name": "El archivo CSV contiene filas con nombre faltante: {{missingFirstName}}",
      "missing_last_name": "El archivo CSV contiene filas con apellido faltante: {{missingLastName}}"
    },
    "import_users_preview": "Vista previa",
    "import_users_csv_button": "Importar CSV",
    "import_users_csv_template": "Descargar Plantilla de CSV",
    "required": "obligatorio",
    "import_button": "Importar",
    "update_existing_users": "Actualizar usuarios existentes",
    "import_users_modal_text": "Crea un archivo CSV: Asegúrate de que tu archivo CSV incluya las siguientes columnas:",
    "import_users_csv_invalid_format": "El formato del archivo CSV no es válido {{header}}",
    "import_users_csv_success": "Resultados de la importación: {{numOfNewUsers}} nuevos usuarios agregados desde el archivo CSV, {{numOfExistingUsers}} usuarios omitidos debido a registros existentes.",
    "import_users_csv_success_update": "Resultados de la importación: {{numOfNewUsers}} nuevos usuarios agregados, {{numOfUpdatedUsers}} usuarios existentes actualizados.",
    "import_users_csv_failure": "Error al importar usuarios {{error}}",
    "invite_users_failure": "Error al invitar a los usuarios {{error}}",
    "search_users_placeholder": "Buscar usuarios",
    "search_pending_users_placeholder": "Search pending members",
    "change_sidecars_settings_failure": "Error al cambiar la configuración del dispositivo",
    "change_sidecars_settings_success": "Configuración del dispositivo cambiada con éxito",
    "filters": {
      "title": "Filtrar usuarios",
      "hide_users": "Mostrar solo activos (Tuvis)",
      "online_only": "Solo en línea",
      "restrict_to_direct_reports": "Restringir a subordinados directos",
      "permissions": "Permisos"
    },
    "tabs": {
      "users": "USUARIOS",
      "pending": "USUARIOS PENDIENTES"
    },
    "cols": {
      "avatar": "Avatar",
      "name": "Ver",
      "username": "Nombre de usuario",
      "phone": "Teléfono",
      "platform": "Plataforma",
      "channels": "Canales",
      "roles": "Roles",
      "profile": "Perfil",
      "created": "Fecha de creación",
      "last_login": "Último acceso",
      "last_login_platform": "Último acceso (Plataforma)",
      "last_login_desktop": "Último acceso (Desktop)",
      "last_login_extension": "Último acceso (Extension)",
      "last_login_mobile": "Último acceso (Móvil)",
      "active_sf": "Activo (SF)",
      "active_tuvis": "Activo (Tuvis)",
      "auto_sync_person": "Modo de sincronización automática predeterminado (Persona)",
      "auto_sync_group": "Modo de sincronización automática predeterminado (Grupo)",
      "groups": "Grupos",
      "userId": "ID de usuario",
      "orgId": "ID de organización",
      "login_provider": "Proveedor de login",
      "login_provider_user_id": "Proveedor de Inicio de Sesión - ID de Usuario",
      "email": "Correo electrónico",
      "manager": "Gerente",
      "online": "En línea",
      "online_tooltip": "En línea en los últimos 5 minutos en {{source}}",
      "offline_tooltip": "Inactivo en los últimos 5 minutos en Tuvis Desktop App"
    },
    "groups": {
      "remove_group": "Eliminar grupo {{name}}",
      "add_group": "Agregar grupo"
    },
    "pending_cols": {
      "email": "Email",
      "invite_date": "Invite date",
      "actions": "Actions"
    },
    "actions": {
      "delete": "Eliminar",
      "confirm_delete_title": "Eliminar usuario",
      "confirm_delete_text": "Eliminar un usuario no se puede deshacer. ¿Estás seguro de que deseas eliminar este usuario?",
      "delete_success": "Usuario eliminado correctamente",
      "delete_failure": "Error al eliminar el usuario",
      "update": "Actualizar",
      "resend_invite": "Reenviar invitación",
      "resend_success": "Invitación reenviada exitosamente",
      "resend_failure": "Error al reenviar la invitación"
    },
    "platform": {
      "extension": "Extensión",
      "desktop": "Desktop",
      "platform": "Plataforma"
    }
  },
  "manageTemplates": {
    "seems_like_no_templates": "Parece que todavía no tienes ninguna plantilla dinámica de mensajes",
    "time_to_create_a_new_one": ", pero es el momento perfecto para crear la primera.",
    "templates_library": "Biblioteca de Plantillas",
    "search_templates": "Buscar plantillas",
    "no_templates_to_show": "No hay plantillas para mostrar",
    "template_name": "Nombre de la plantilla",
    "status": "Estado",
    "visibility": "Visibilidad",
    "message": "Mensaje",
    "owner": "Propietario",
    "created_date": "Fecha de creación",
    "last_modified": "Última modificación",
    "filters_title": "FILTRAR PLANTILLAS",
    "filters_status": "Estado",
    "filters_visibility": "Visibilidad",
    "filters_visibility_hidden": "Oculto",
    "filters_visibility_visible": "Visible",
    "delete_template_modal_part_1": "¿Estás seguro de que deseas eliminar la",
    "delete_template_modal_part_2": "plantilla?",
    "delete_template_modal_title": "Eliminar plantilla",
    "delete_template_modal_ok": "Eliminar",
    "selected_templates": "Plantillas",
    "delete_templates": "Eliminar plantillas",
    "delete_templates_modal_title": "Eliminar plantillas",
    "delete_templates_modal_ok": "Eliminar",
    "delete_templates_modal_text": "¿Estás seguro de que deseas eliminar {{count}} plantillas?",
    "activate_templates": "Activar plantillas",
    "activate_templates_modal_title": "Activar plantillas",
    "activate_templates_modal_ok": "Activar",
    "activate_templates_modal_text": "¿Estás seguro de que deseas activar {{count}} plantillas?",
    "stop_templates": "Detener plantillas",
    "stop_templates_modal_title": "Detener plantillas",
    "stop_templates_modal_ok": "Detener",
    "stop_templates_modal_text": "¿Estás seguro de que deseas detener {{count}} plantillas?"
  },
  "create_or_edit_templates": {
    "template_preview_placeholder": "Mensaje de plantilla",
    "template_preview": "Vista previa de la plantilla",
    "too_many_file_upload": "Puedes subir hasta 4 archivos. Si deseas cambiar los archivos, por favor, elimina el archivo seleccionado primero.",
    "failed_to_save": "No se pudo guardar la plantilla",
    "template_must_have_name": "La plantilla debe tener un nombre",
    "template_must_include_message": "La plantilla debe incluir un mensaje",
    "save": "Guardar",
    "template": "PLANTILLA",
    "template_name": "Nombre de la Plantilla",
    "settings": "AJUSTES",
    "status": "Estado",
    "active": "Activo",
    "stopped": "Detenido",
    "public": "Público",
    "editable": "Editable",
    "visibility_rules": "Reglas de visibilidad",
    "choose_users": "Elija qué usuarios pueden ver y utilizar esta plantilla.",
    "add_new_rule": "Añadir Nueva Regla",
    "message": "Mensaje",
    "insert_personalized_token": "Insertar un token personalizado",
    "visibility_rules_section": "REGLAS DE VISIBILIDAD",
    "search_rule_name": "Buscar nombre de regla",
    "search_personalized_token": "Buscar token personalizado",
    "create_template": "Crear Plantilla",
    "edit_template": "Editar Plantilla",
    "personalized_modal": {
      "title": "Establecer valor predeterminado para {{personalizedLabel}}",
      "done": "Hecho",
      "default_value": "Valor predeterminado",
      "text_trans": {
        "header": "Transformaciones",
        "lowercase": "minúsculas",
        "uppercase": "MAYÚSCULAS",
        "capitalize": "Capitalizar Cada Palabra",
        "none": "Ninguno"
      }
    },
    "upload_images": {
      "upload_images": "Subir Archivos",
      "record_audio": "Grabar mensaje de voz",
      "recording_audio": "Grabando mensaje de voz",
      "up_to_4_images": "Hasta 4 archivos",
      "supported_files": "Archivos compatibles: jpg, png, gif, pdf, ogg, aac, amr",
      "recommended_max_size": "Tamaño máximo: 3 MB.",
      "recording_cannot_have_text": "No se puede enviar una grabación con texto, el mensaje de la plantilla se ignorará",
      "file_exceeds_size_limit": "Archivo(s) excedieron el límite de {{maxSize}} MB y no fueron subidos: {{fileNames}}"
    }
  },
  "common": {
    "open_salesforce": "Volver a Salesforce",
    "crm_table": {
      "no_results_found": "No se encontraron resultados",
      "try_other_filters_combination": "Prueba otra combinación de filtros",
      "try_different_keywords": "Prueba con palabras clave diferentes o asegúrate",
      "spelled_correctly": "de que todo esté escrito correctamente."
    }
  },
  "tuvisSetup": {
    "welcome": "Bienvenido a Tuvis",
    "description": "¿Necesitas ayuda para empezar o conocer más acerca de nuestras funciones?",
    "doc_link": "Consulta nuestra documentación"
  },
  "adminNotifications": {
    "user_logged_out": "Usuario desconectado",
    "user_uninstall_extension": "El usuario desinstaló la extensión",
    "user_turned_auto_sync_off": "El usuario ha desactivado la sincronización automática",
    "user_turned_auto_sync_on": "El usuario ha activado la sincronización automática",
    "user_turned_group_auto_sync_on": "El usuario ha activado la sincronización automática de grupo",
    "user_turned_group_auto_sync_off": "El usuario ha desactivado la sincronización automática de grupo",
    "api_currently_disabled": "API actualmente desactivada",
    "apex_rest_services_disabled": "Servicios REST de APEX desactivados",
    "new_user_created": "Nuevo usuario creado",
    "user_logged_in": "Usuario conectado",
    "title": "Notificaciones",
    "saveSettings": "Guardar configuraciones",
    "subHeader": "Notifícame sobre...",
    "recipients": "Destinatarios:",
    "recipients_text": "Agrega escribiendo la dirección de correo electrónico o buscando por nombre (Usa “,” para agregar varios miembros)",
    "saved_successfully": "La configuración de notificaciones se guardó correctamente",
    "saved_failed": "Error al guardar la configuración de notificaciones"
  },
  "globalLayout": {
    "title": "Layout Global",
    "failed_to_update_hide_edit_layout": "Error al actualizar \"Ocultar diseño de edición\", por favor intente nuevamente más tarde",
    "hide_edit_layout": "Ocultar editar layout",
    "reset_user_layout": "Restablecer el diseño de todos los usuarios de la organización",
    "reset_user_layout_confirm": "¿Estás seguro de que deseas restablecer el diseño de todos los usuarios de la organización?",
    "reset_user_layout_success": "El diseño de todos los usuarios de la organización se restableció correctamente",
    "reset_user_layout_failure": "Error al restablecer el diseño de todos los usuarios de la organización",
    "copy_another_org_global_layout": "Copiar la disposición global de otra organización",
    "yes": "Sí",
    "back": "Atrás",
    "select_organization_to_copy_global_layout_from": "Selecciona la organización desde la que deseas copiar la disposición global",
    "select": "Seleccionar",
    "validate_copy_global_layout_from_other_org": {
      "row_1": "¿Estás seguro de que quieres copiar la disposición global?",
      "row_2": "Desde:",
      "row_3": "Hacia:"
    }
  },
  "record_type_layout": {
    "select_record_type": "Seleccionar tipo de registro",
    "record_type": "Tipo de registro",
    "edit": "Editar",
    "manage_record_types": "Administrar tipos de registro",
    "edit_record_type": "Editar tipo de registro",
    "select_record_types_to_display": "Seleccionar tipos de registro para mostrar bajo el prospecto:",
    "make_default": "Establecer como predeterminado",
    "default": "Predeterminado"
  },
  "entity_unknown": "Desconocido",
  "entity_contact": "Contacto",
  "entity_lead": "Prospecto",
  "entity_person_account": "Cuenta personal",
  "entity_person_account_label": "cuenta personal",
  "entity_new_person_account": "Nuevo cuenta personal",
  "entity_sf_manager": "Salesforce Manager",
  "entity_account": "Cuenta",
  "entity_person": "Persona",
  "entity_opps": "Oportunidad",
  "entity_activity": "Actividad",
  "entity_activity_label": "actividad",
  "entity_task": "Tarea",
  "entity_task_label": "tarea",
  "entity_case": "Caso",
  "entity_new_lead": "Nuevo Prospecto",
  "entity_new_contact": "Nuevo Contacto",
  "entity_new_account": "Nueva Cuenta",
  "entity_new_activity": "Nueva Actividad",
  "entity_new_task": "Nueva Tarea",
  "entity_new_case": "Nuevo Caso",
  "entity_new_event": "Nuevo Evento",
  "opp_form_fields_modal": {
    "submit": "Guardar",
    "cancel": "Cancelar",
    "title": "Cerrar esta oportunidad"
  },
  "action_button_event": "Evento",
  "clear_all": "Quitar todos",
  "helpers_form_layouts": "Campos de Formulario",
  "editLayouts": {
    "edit_global_layouts": "Editar visualización general",
    "editing_the_global_layout_affects_all_records": "Editar la visualización general afecta todos los registros",
    "select_layout_type": "Selecciona el tipo de vista",
    "display_record_layout": "MOSTRAR REGISTRO DE CAMPOS",
    "select_up_to_display_fields": "Selecciona hasta {{numberOfFields}} campos de visualización",
    "save_changes": "Guardar cambios",
    "multiple_record_preview": "Vista previa de varios registros",
    "search_field_name": "Nombre del campo de búsqueda",
    "mandatory_field": "Campo obligatorio",
    "add_fields": "agregar campos",
    "always_require_a_value": "Siempre se requiere un valor en este campo para poder guardar un registro",
    "you_can_only_select_up to_fields": "Puedes seleccionar hasta {{numberOfFields}} campos máximo"
  },
  "helpers_add_new_field": "Agregar nuevos campos",
  "tuvis_messaging_app": {
    "template_sent": "Su cliente ha sido notificado (usando {{templateName}}) y recibirá su mensaje tan pronto como acepte la invitación a la conversación. Estamos esperando su respuesta para continuar el diálogo."
  },
  "incidents_summary_email": {
    "title": "Correo electrónico de resumen de incidentes",
    "saved_successfully": "La configuración del correo electrónico de resumen de incidentes se guardó correctamente",
    "saved_failed": "Error al guardar la configuración del correo electrónico de resumen de incidentes",
    "loading": "Cargando...",
    "sub_header": "Permitir el envío de resumen de incidentes a los correos electrónicos seleccionados",
    "allow_incidents_summary_email": "Permitir correo electrónico de resumen de incidentes",
    "recipients": "Destinatarios:",
    "recipients_text": "Agregue escribiendo la dirección de correo electrónico o buscando por nombre (Use “,” para agregar varios miembros)",
    "saveSettings": "Guardar configuración"
  }
}
